import { ArtWork, Product } from "../../types/ArtWork";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ProductCard } from "./ProductCard";
import { useMediaQuery } from "../../hooks/useMediaQuery";

export function ProductsExplorer({
  artWork,
  minView,
}: {
  artWork: ArtWork | undefined;
  minView?: boolean;
}) {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery("(min-width: 920px)");
  const products = artWork?.products || [];

  const groupProducts = (items: Product[]) => {
    const stepSize = isDesktop ? 3 : 2;
    const grouped: Product[][] = [];
    for (let i = 0; i < items.length; i += stepSize) {
      grouped.push(items.slice(i, i + stepSize));
    }
    return grouped;
  };

  const groupedProducts = groupProducts(products);
  const [activeGroup] = useState(
    minView ? Math.floor(Math.random() * Math.max(groupedProducts.length, 1)) : 0,
  );
  const [carouselIndex, setCarouselIndex] = useState(0);

  if (!products.length) return null;

  const displayProducts = minView
    ? groupedProducts[activeGroup] || products.slice(0, isDesktop ? 3 : 2)
    : isDesktop
      ? groupedProducts[carouselIndex] || products
      : products;

  return (
    <section className="border-t border-canvas-200/60 bg-canvas-100/50 py-12 sm:py-16">
      <div className="section-container">
        <div className="mb-8 flex items-center justify-between">
          <div>
            <p className="text-sm font-medium uppercase tracking-[0.15em] text-accent">
              {t("artwork.shopEyebrow")}
            </p>
            <h2 className="mt-1 font-display text-2xl font-semibold text-canvas-950">
              {t("artwork.shopTitle")}
            </h2>
          </div>
          {isDesktop && groupedProducts.length > 1 && !minView && (
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() =>
                  setCarouselIndex(
                    (prev) =>
                      (prev - 1 + groupedProducts.length) %
                      groupedProducts.length,
                  )
                }
                className="btn-secondary !px-3 !py-2 !text-xs"
                aria-label={t("common.prev")}
              >
                {t("common.prev")}
              </button>
              <button
                type="button"
                onClick={() =>
                  setCarouselIndex((prev) => (prev + 1) % groupedProducts.length)
                }
                className="btn-secondary !px-3 !py-2 !text-xs"
                aria-label={t("common.next")}
              >
                {t("common.next")}
              </button>
            </div>
          )}
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {displayProducts.map((product, index) => (
            <ProductCard key={index} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
}
